import type { Tour } from '@carboncopyco/types';
import {
  SMALL_SCREEN_BREAKPOINT,
  useShowResponsiveBanner,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren, type RefObject, useState } from 'react';

import { TourSmallScreen } from '../../components/TourSmallScreen';
import { getTourBackgroundStyles } from '../../utils';

type ToursReplayerPreviewWrapperProps = {
  draftSettings?: Tour['draftSettings'];
  fileServiceApiToken: string;
  previewContainerRef?: RefObject<HTMLDivElement>;
};

export const ToursReplayerPreviewWrapper = ({
  draftSettings,
  children,
  fileServiceApiToken,
  previewContainerRef,
}: PropsWithChildren<ToursReplayerPreviewWrapperProps>) => {
  const { toursShowSmallScreenWarning } = useFlags();
  const [isResponsiveBannerTurnedOff, setIsResponsiveBannerTurnedOff] =
    useState(false);
  const isSmallScreen = useShowResponsiveBanner(SMALL_SCREEN_BREAKPOINT);

  const showSmallScreenBanner =
    isSmallScreen &&
    toursShowSmallScreenWarning &&
    !isResponsiveBannerTurnedOff;

  const shouldBlurBackground =
    draftSettings?.background?.backgroundType === 'image' &&
    draftSettings?.background?.blur &&
    !showSmallScreenBanner;

  return (
    <div
      ref={previewContainerRef}
      className="h-full w-full bg-cover"
      style={getTourBackgroundStyles({
        tourSettings: draftSettings,
        fileServiceApiToken,
      })}
    >
      {shouldBlurBackground && (
        <div className="backdrop-blur-xl absolute w-full h-full" />
      )}
      {showSmallScreenBanner && (
        <TourSmallScreen onClose={() => setIsResponsiveBannerTurnedOff(true)} />
      )}
      <div
        className={classNames(
          'w-full h-full flex items-center justify-center',
          {
            hidden: showSmallScreenBanner,
          }
        )}
      >
        {children}
      </div>
    </div>
  );
};
